import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import DeleteIcon from "@material-ui/icons/Delete";
import Autorenew from "@material-ui/icons/Autorenew";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";

import EditCred from "./Edit.js";
import Create from "./Create";
import Info from "./Info";

var cronValidator = require("cron-expression-validator");

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Credentials() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [searchitems, setSearchItems] = React.useState(0);

  const [schedulelist, setSchedulelist] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationschedulelist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setSchedulelist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [state, setState] = React.useState({
    delete_id: "",
  });

  const Delete = (userId) => {
    return function () {
      fetch(`${process.env.REACT_APP_API_URL}/api/schedule/${userId}/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          window.top.location.reload(false);
        })
        .catch((error) => {
          console.log(error);
          window.location.reload();
        });
    };
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  function del(deleteid) {
    setState({ delete_id: deleteid });
  }

  function refreshPage() {
    window.location.reload();
  }

  const unique = [
    ...new Set(
      schedulelist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const [one, setone] = React.useState(false);

  const oneopen = () => {
    setone(true);
  };

  const oneClose = () => {
    setone(false);
  };

  const cloumnName = "name";
  return (
    <>
      <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
        <div className="relative flex flex-wrap items-stretch">
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Schedule name here..."
            onChange={(event) => {
              console.log(event.target.value);
              setSearchItems(event.target.value);
            }}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form>
      <br />
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
        <Create open={open} Transition={Transition} setOpen={setOpen} />
        <Card>
          <CardHeader
            action={
              <React.Fragment>
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  style={{ float: "right" }}
                  onClick={handleClickOpen}
                >
                  Add Schedule
                </button>
              </React.Fragment>
            }
            title="SCHEDULE LIST"
          />
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Cron Expression (UTC)</TableCell>
                    <TableCell align="center">Info</TableCell>
                    {window.localStorage.getItem("audit_run_access") ===
                    "You do not have permission to perform this action." ? (
                      ""
                    ) : (
                      <React.Fragment>
                        <TableCell align="center">Delete</TableCell>
                      </React.Fragment>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {unique
                    .slice(page * limit, page * limit + limit)
                    .filter((val) => {
                      if (searchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName]
                          .toLowerCase()
                          .includes(searchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    })
                    .map((sche) => (
                      <TableRow hover key={sche.id}>
                        <TableCell align="center">
                          {sche.serial_number}
                        </TableCell>
                        <TableCell align="center">{sche.name}</TableCell>
                        <TableCell align="center">
                          {sche.cron_expression}
                        </TableCell>
                        <TableCell align="center">
                          <Info
                            profile_id={sche.profile}
                            host_id={sche.hosts}
                          />
                        </TableCell>

                        {window.localStorage.getItem("audit_run_access") ===
                        "You do not have permission to perform this action." ? (
                          ""
                        ) : (
                          <React.Fragment>
                            <TableCell align="center">
                              <IconButton
                                title="Delete"
                                aria-label="delete"
                                id="delete"
                                style={{
                                  padding: "0px",
                                  color: "#e68383",
                                }}
                              >
                                <DeleteIcon
                                  fontSize="small"
                                  onClick={() => {
                                    oneopen();
                                    window.sessionStorage.setItem(
                                      "schedulename",
                                      sche.name
                                    );
                                    del(sche.id);
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          </React.Fragment>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <TablePagination
            component="div"
            count={schedulelist.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Card>
        <Dialog
          open={one}
          TransitionComponent={Transition}
          keepMounted
          onClose={oneClose}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            DELETE SCHEDULE
          </h2>

          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete{" "}
              <strong>{window.sessionStorage.getItem("credentialname")}</strong>{" "}
              ?{" "}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <button
              className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={() => refreshPage()}
              size="sm"
            >
              Cancel
            </button>
            <button
              className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={Delete(state.delete_id)}
            >
              Delete
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}